<template>
    <ion-page>
        <standard-header title="All Picks" align="middle"/>
        <ion-content :fullscreen="true">
            <pull-down-refresh :callback="refresh"/>
            <skeleton :rows="4" v-if="shipments === null"/>
            <ion-list>
                <ion-item>
                    <ion-label>Filter by Drop Off</ion-label>
                    <ion-select v-model="currentZoneId">
                        <ion-select-option :value="null">All</ion-select-option>
                        <ion-select-option :value="zone.id" v-for="zone in zones" :key="zone.id">
                            {{ zone.name }}
                        </ion-select-option>
                    </ion-select>
                </ion-item>
                <div v-for="shipment in filteredShipments" :key="shipment.id">
                    <ion-item lines="none" class="ion-no-padding">
                        <ion-button fill="clear" size="small" style="height: 100%" @click="showLines(shipment)">
                            <ion-icon slot="icon-only" :icon="listOutline"/>
                        </ion-button>
                        <pick-list-item
                            :shipment="shipment"
                            :hide-due="true"
                            :duration-source="shipment.pickers"
                        />
                        <shipment-stock-take-user-assignment
                            :lineable-update-url="`/api/shipments/${shipment.id}/users`"
                            user-permission="warehouse.pick"
                            :lineable="shipment"
                            :users="users"
                            users-property="pickers"
                            :update-payload="{action:'none', stage: 'pick'}"
                        />
                    </ion-item>
                    <ion-progress-bar :value="shipment.pc_complete/100"/>
                </div>
            </ion-list>
            <div v-show="filteredShipments && filteredShipments.length < 1">
                <no-results title="No Results">
                    No shipments found due for picking
                </no-results>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonContent,
    IonItem,
    IonList,
    IonPage,
    IonProgressBar,
    IonButton,
    IonIcon,
    IonLabel,
    IonSelect,
    IonSelectOption,
    alertController
} from '@ionic/vue';
import {listOutline} from 'ionicons/icons';
import StandardHeader from "@/components/StandardHeader.vue";
import NoResults from "@/components/NoResults";
import EventBus from '@/EventBus';
import Skeleton from "@/components/Skeleton";
import PullDownRefresh from "@/components/PullDownRefresh";
import PrioritySorter from "@/services/PrioritySorter";
import PickListItem from "@/views/modules/picking/components/PickListItem";
import _ from 'lodash';
import router from "@/router";
import ShipmentStockTakeUserAssignment from "@/components/ShipmentStockTakeUserAssignment";

export default {
    inject: ['$http', '$toast', '$validationAlert'],
    name: 'AllPicksList',
    components: {
        ShipmentStockTakeUserAssignment,
        PickListItem,
        PullDownRefresh,
        Skeleton,
        NoResults,
        StandardHeader,
        IonContent, IonPage, IonItem, IonList, IonButton, IonIcon,
        IonSelect, IonSelectOption, IonLabel,
        IonProgressBar
    },
    data() {
        return {
            currentZoneId: null,
            shipments: null,
            users: [],
            zones: []
        }
    },
    async mounted() {
        EventBus().emitter.emit('loading', true);
        await this.getUsers();
        await this.refresh();
        await this.$http.get('/api/locations/zones?search=is_bay:1').then(response => {
            this.zones = response.data.items;
        });
        EventBus().emitter.emit('loading', false);
    },
    computed: {
        filteredShipments() {
            if (!this.currentZoneId) {
                return this.shipments;
            }
            return _.filter(this.shipments, shipment => {
                return shipment.picking_drop_off_zone_id === this.currentZoneId;
            });
        }
    },
    methods: {
        jumpToPick(shipment) {
            console.log(shipment);
            router.push({name: 'picks.pick', params: {id: shipment.id}});
        },
        showLines(shipment) {
            alertController.create({
                header: shipment.reference,
                message: _.map(shipment.lines, (line) => {
                    return `&bull; ${line.qty_required} x ${line.item.item_number} @ ${line.location.code}`;
                }).join('<br />'),
                buttons: [{
                    text: 'Jump To Pick',
                    handler: () => {
                        this.jumpToPick(shipment);
                    }
                }, 'Close']
            }).then(alert => alert.present());
        },
        async getUsers() {
            return this.$http.get('/api/users', {
                params: {permissions: 'warehouse.pick', all: true}
            }).then(response => {
                this.users = response.data.items;
            }).catch(error => {
                this.$validationAlert(error);
            });
        },
        refresh(event = null) {
            return this.$http.get('/api/picks/shipments', {
                params: {include: 'pickers,lines,lines.item,lines.location', all: true}
            }).then(response => {
                this.shipments = PrioritySorter.sortByPriorityThen(response.data.items, 'reference');
            }).finally(() => {
                if (event && event.target.complete) {
                    event.target.complete();
                }
            });
        }
    },
    setup() {
        return {listOutline};
    }
}
</script>
